import React from "react";
import MapTooltip from "./MapTooltip";

const ClusterListItem = ({
  project,
  mapInstance,
  setSelectedProjectId,
  getProjectPosition,
  setImagePreview,
  translations,
  user,
  setDeletingProject,
  setShowDeleteModal,
  isInsideCluster,
}) => {
  return (
    <div
      key={project?.id}
      className="map-cluster-info__item"
    >
      <MapTooltip
        mapInstance={mapInstance}
        getProjectPosition={getProjectPosition}
        selectedProject={project}
        setImagePreview={setImagePreview}
        translations={translations}
        setSelectedProjectId={setSelectedProjectId}
        user={user}
        setDeletingProject={setDeletingProject}
        setShowDeleteModal={setShowDeleteModal}
        isInsideCluster={isInsideCluster}
      />
    </div>
  );
};

export default ClusterListItem;
